import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './ArtAdvisoryCallout.module.scss'
import useQA from 'hooks/useQA'

const ArtAdvisoryCallout: FC = () => {
  const { testId } = useQA()

  return (
    <div
      className={styles.artAdvisoryCalloutContainer}
      {...testId('art-advisory-callout-container')}
    >
      <div className={styles.artAdvisoryCallout} {...testId('art-advisory-callout')}>
        <div className={styles.imageSection}>
          <img
            className={styles.image}
            src='//d3t95n9c6zzriw.cloudfront.net/homepage/art_advisory_image.jpg'
            width='536'
            height='536'
          />
        </div>
        <div className={styles.textSection} {...testId('art-advisory-text')}>
          <div className={styles.titleText}>
            <h4 className={styles.title}>Complimentary Art Advisory</h4>
            <p className={styles.text}>
              Our free and flexible art advisory service pairs you with a knowledgeable curator who
              will guide you through a seamless, stress-free process to find artwork for sale that fits your
              needs.
            </p>
          </div>
          <SALink href='/artadvisory' title='Work with a curator'>
            <p className={styles.buttonText}>Work with a curator</p>
          </SALink>
        </div>
      </div>
    </div>
  )
}

export default ArtAdvisoryCallout
